module.exports = __webpack_public_path__ + "img/logo.87770007.png";